import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  catering: (data) => axios.post(`${API}/catering`, data),
  contact: (data) => axios.post(`${API}/contact`, data),
  reservation: (data) => axios.post(`${API}/reservations`, data),
  newsletter: (data) => axios.post(`${API}/newsletter`, data),
  chatUrl: `${API}/chat`,
};
